import React from "react";

const PhotoTitle = props => {
    return (
        <h2>{props.title}</h2>
    )
};

export default PhotoTitle;